export default "<app-shared-article-details\n    [article]=\"values.article\"\n    [showStock]=\"showStock\"\n></app-shared-article-details>";